<div id="add-report-items-modal" class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Select Item to Add</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>

    <div class="ttmodal__body" style="width: 580px; height:420px">
        <div style="display: flex; flex-direction: row; padding-bottom: 40px;">
            <a class="button waves-effect btnItemToAdd">
                <i class="material-icons button__icon fullSizedIcon">table_chart</i>
                <p class="button__text btnIconText">Measurements</p>
            </a>
            <a class="button waves-effect btnItemToAdd">
                <i class="material-icons button__icon fullSizedIcon">insert_photo</i>
                <p class="button__text btnIconText">Photos</p>
            </a>
            <a class="button waves-effect btnItemToAdd">
                <i class="material-icons button__icon fullSizedIcon">subject</i>
                <p class="button__text btnIconText">Paragraph</p>
            </a>
            <a class="button waves-effect btnItemToAdd">
                <i class="material-icons button__icon fullSizedIcon">text_format</i>
                <p class="button__text btnIconText">Title</p>
            </a>
        </div>

        <div id="itemSelected_Measurements">
            <span>Select a component or measurement</span>
        </div>

        <div id="itemSelected_Photos">

        </div>

        <div id="itemSelected_Paragraph">

        </div>

        <div id="itemSelected_Title">

        </div>
    </div>
</div>
